import { type TOption } from '@intellecteu/common-ui';

export const selectOptionsAdapter = (arr: Array<string | number>): TOption[] =>
  arr.map((el) => ({ value: String(el), label: String(el) }));

export const selectValueAdapter = (arr: TOption[], value: string): TOption | string =>
  arr?.find((el) => el.value === value) ?? '';
